const Error = () => {
    return (
        <div>
            <h1>Oop's</h1>
        </div>
    )
}

export default Error